import { useEffect } from 'react'
import { useUpcomingTaskCount } from './useUpcomingTaskCount'

type CountedSpace = 'personal' | 'work' | 'home'
const COUNTED_SPACES: readonly string[] = ['personal', 'work', 'home']

/**
 * **Die Zahl auf dem Dock-Symbol** — dieselbe wie neben „Demnächst" im aktiven
 * Lebensbereich. Den Rest macht der Main-Prozess (`dockBadge.ts`, nur macOS).
 *
 * Geschickt wird bei jeder Änderung und wenn das Fenster nach vorn kommt: Bei
 * mehreren Hauptfenstern (abgerissene Tabs) mit verschiedenen Bereichen zeigt
 * das Dock so die Zahl des Fensters, das vorn ist.
 *
 * Im Bereich „Alle" gibt es kein „Demnächst", dort bleibt das Dock leer.
 */
export function useDockBadge(lifeSpace: string): void {
  const counted = COUNTED_SPACES.includes(lifeSpace)
  // Der Zähler braucht einen echten Bereich, auch wenn „Alle" ihn verwirft.
  const count = useUpcomingTaskCount((counted ? lifeSpace : 'personal') as CountedSpace)
  const badge = counted ? count : 0

  useEffect(() => {
    const api = window.api
    if (!api?.invoke) return
    const send = () => {
      void Promise.resolve(api.invoke('dock:badge', badge)).catch(() => {})
    }
    send()
    window.addEventListener('focus', send)
    return () => window.removeEventListener('focus', send)
  }, [badge])
}
